import React, { useState, useEffect } from "react";
import { C, T, BG } from "../constants/baziData";
import { API } from "../constants/config";

function HistoryPage({lang="en",setPage,setSelectedReport}){
  const [reports,setReports]=useState([]);
  useEffect(()=>{
    const hist=JSON.parse(localStorage.getItem("lumina_history")||"[]");
    setReports(hist);
  },[]);

  const handleDelete=(idx)=>{
    if(!window.confirm(lang==="zh"
      ?"确认删除这份报告？此操作不可撤销。"
      :"Delete this report? This cannot be undone.")) return;
    const hist=JSON.parse(localStorage.getItem("lumina_history")||"[]");
    hist.splice(idx,1);
    localStorage.setItem("lumina_history",JSON.stringify(hist));
    setReports([...hist]);
  };

  const handleDownloadPDF=async(r)=>{
    const token=localStorage.getItem("lumina_token");
    if(!token){
      alert(lang==="zh"?"请先登录以下载PDF":"Please sign in to download PDF");
      return;
    }
    try{
      const resp=await fetch(`${API}/audit/deep/pdf`,{
        method:"POST",
        headers:{"Content-Type":"application/json","Authorization":`Bearer ${token}`},
        body:JSON.stringify({
          name:r.name,
          birth_year:r.birthYear,
          birth_month:r.birthMonth,
          birth_day:r.birthDay,
          birth_hour:r.birthHour,
          gender:r.gender||"M",
          city:r.city||"",
        }),
      });
      if(!resp.ok){
        alert(lang==="zh"?"下载失败，请确认L1权限":"Download failed. L1 required.");
        return;
      }
      const blob=await resp.blob();
      const url=URL.createObjectURL(blob);
      const a=document.createElement("a");
      a.href=url;
      a.download=`LUMINAARC_${r.name||"report"}_${r.birthYear||""}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    }catch(e){
      alert(lang==="zh"?"网络错误":"Network error");
    }
  };

  if(!reports.length)return(
    <div style={{maxWidth:700,margin:"60px auto",padding:"0 20px",textAlign:"center"}}>
      <div style={{background:"rgba(255,255,255,.72)",border:"1px solid rgba(212,175,55,.16)",backdropFilter:"blur(12px)",borderRadius:14,padding:40}}>
        <div style={{fontSize:16,color:C.gold,fontFamily:"'Inter','Montserrat',sans-serif",marginBottom:8}}>{T[lang].noReports}</div>
        <div style={{fontSize:16,color:C.mist4,marginBottom:20}}>{T[lang].noReportsSub}</div>
        <button style={{...BG,width:"auto",padding:"10px 28px"}} onClick={()=>setPage("audit")}>{T[lang].generateFirst}</button>
      </div>
    </div>
  );

  return(
    <div style={{maxWidth:700,margin:"0 auto",padding:"40px 20px"}}>
      <div style={{marginBottom:20}}>
        <div style={{fontSize:18,color:C.gold,fontFamily:"'Inter','Montserrat',sans-serif",marginBottom:4}}>{T[lang].reportsTitle}</div>
        <div style={{fontSize:16,color:C.mist2}}>{reports.length} audit{reports.length!==1?"s":""} {lang==="zh"?"份报告":"generated"}</div>
      </div>
      <div style={{display:"flex",flexDirection:"column",gap:10}}>
        {reports.map((r,i)=>(
          <div key={i} style={{
            background:"rgba(255,255,255,.65)",
            border:"1px solid rgba(212,175,55,.14)",
            borderRadius:10,padding:"16px 20px",
            display:"flex",alignItems:"center",gap:12,
          }}>
            {/* Left: clickable report summary */}
            <div style={{flex:1,cursor:"pointer"}}
              onClick={()=>{setSelectedReport(r);setPage("report");}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  <div style={{fontSize:18,color:C.gold,marginBottom:6,fontWeight:"500"}}>{r.name}</div>
                  <div style={{fontSize:16,color:C.mist2}}>
                    {r.pillars?.year?.gz} {r.pillars?.month?.gz} {r.pillars?.day?.gz} {r.pillars?.hour?.gz}
                  </div>
                  <div style={{fontSize:12,color:C.mist5,marginTop:3}}>{r.rid}</div>
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{fontSize:24,color:r.sc?.tier?.color||C.gold}}>{r.sc?.overall}</div>
                  <div style={{fontSize:11,color:C.mist5}}>/ 100</div>
                  <div style={{fontSize:12,color:r.sc?.tier?.color||C.gold,marginTop:2}}>{r.sc?.tier?.label}</div>
                </div>
              </div>
            </div>

            {/* Right: action buttons */}
            <div style={{display:"flex",flexDirection:"column",gap:6,flexShrink:0}}>
              <button
                onClick={(e)=>{e.stopPropagation();handleDownloadPDF(r);}}
                title={lang==="zh"?"下载PDF":"Download PDF"}
                style={{
                  padding:"5px 10px",borderRadius:6,fontSize:12,
                  background:"rgba(212,175,55,0.10)",border:"1px solid rgba(212,175,55,0.25)",
                  color:"#8B6914",cursor:"pointer",
                }}
              >📥</button>
              <button
                onClick={(e)=>e.stopPropagation()}
                title={lang==="zh"?"发到邮箱（即将开放）":"Email report (coming soon)"}
                disabled
                style={{
                  padding:"5px 10px",borderRadius:6,fontSize:12,
                  background:"rgba(0,0,0,0.04)",border:"1px solid rgba(0,0,0,0.08)",
                  color:"#CBD5E0",cursor:"not-allowed",
                }}
              >📧</button>
              <button
                onClick={(e)=>{e.stopPropagation();handleDelete(i);}}
                title={lang==="zh"?"删除":"Delete"}
                style={{
                  padding:"5px 10px",borderRadius:6,fontSize:12,
                  background:"rgba(239,68,68,0.06)",border:"1px solid rgba(239,68,68,0.18)",
                  color:"#EF4444",cursor:"pointer",
                }}
              >🗑</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HistoryPage;
